module.exports = __webpack_public_path__ + "static/img-founded-with-indiegogo-165cc42b8d59e2c2819b1a85ac49fc7a.png";